// index.js (API clients)
import axios from "axios";
import { socketio } from '../env/environment';
import { msalInstance } from "../auth/msalConfig";
import { acquireApiToken } from "../auth/token-renewal"; // we'll export the helper from checkLoginStatus file

// Create axios clients
export const client = axios.create({
    baseURL: "/api",
    headers: { "Content-Type": "application/json" }
});

export const clientHC = axios.create({
    baseURL: "/apiHC",
    headers: { "Content-Type": "application/json" }
});

// Always attach latest JWT from sessionStorage
function attachToken(config) {
    const token = sessionStorage.getItem("jwt");
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
}

client.interceptors.request.use(attachToken);
clientHC.interceptors.request.use(attachToken);

// Retry once if token expired (401 from backend)
async function retryOn401(error) {
    if (error.response && error.response.status === 401) {
        console.warn("401 detected — trying silent token refresh");
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            try {
                const newToken = await acquireApiToken(accounts[0]); // get fresh token
                sessionStorage.setItem("jwt", newToken);
                error.config.headers["Authorization"] = `Bearer ${newToken}`;
                return client.request(error.config); // retry original request
            } catch (err) {
                console.error("Token refresh failed — forcing login");
                msalInstance.loginPopup();
            }
        }
    }
    return Promise.reject(error);
}

client.interceptors.response.use(res => res, retryOn401);
clientHC.interceptors.response.use(res => res, retryOn401);

// Socket URL export
export const socketUrl = socketio.url;



// WEBPACK FOOTER //
// ./src/actions/index.js